module.exports = __webpack_public_path__ + "img/logo.ea23ec91.png";